import { AxiosPromise } from "axios";
import {
  MemberDto,
  MembersResourceApi,
  UpdateMemberDto,
} from "../generated/dashboard-client";
import { dashboardApiConfig, ops } from "./config";

const api = new MembersResourceApi(dashboardApiConfig);

const AccountMembersApi = {
  updateMember(memberId: string, dto: UpdateMemberDto): AxiosPromise<void> {
    return api.updateMember(memberId, dto, ops());
  },
  updateLocationsForMember(
    memberId: string,
    locations: Array<string>
  ): AxiosPromise<MemberDto> {
    return api.updateLocationsForMember(memberId, locations, ops());
  },
};

export default AccountMembersApi;
